

/* Media Thumbnail Slider */
/* Product Media*/
function onClick(element) {
  var img = document.getElementById("img01").src = element.src;
  
  document.getElementById("modal01").style.display = "block";
}
/* Product Media*/
$(document).ready(function(){
  


/* Media Thumbnail Slider */
$('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    asNavFor: '.slider-nav'
});
$('.slider-nav').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    vertical:true,
    asNavFor: '.slider-for',
    dots: false,
    focusOnSelect: true,
    verticalSwiping:true,
    responsive: [
    {
        breakpoint: 992,
        settings: {
          vertical: false,
        }
    },
    {
      breakpoint: 768,
      settings: {
        vertical: false,
      }
    },
    {
      breakpoint: 580,
      settings: {
        vertical: false,
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 380,
      settings: {
        vertical: false,
        slidesToShow: 2,
      }
    }
    ]
});
/* Media Thumbnail Slider */ 

  
  });
/* Media Thumbnail Slider */ 